import api, { API_VERSIONS } from "@/config/api";
import { recoverTokenInfo } from "@/utils/recoverTokenInfo";

export async function getUploadURL(recordingUUID: string, deviceKey: string): Promise<string> {
  const initialToken = recoverTokenInfo();

  const url = `/${API_VERSIONS.v0}/file/uploadchunksurl/${recordingUUID}`;

  const response = await api.get(url, {
    headers: {
      Accept: "*/*",
      Authorization: `Bearer ${initialToken}`,
      "X-iBabs-Device-Id": deviceKey,
    },
  });

  if (typeof response.data === "string") {
    return response.data;
  }

  return response.data as string;
}

export const ensureRecordingIdInUploadURL = (uploadURL: string, recordingId: string): string => {
  try {
    const parsedURL = new URL(uploadURL);
    const pathSegments = parsedURL.pathname.split("/").filter(Boolean);

    if (pathSegments.length === 0) {
      return uploadURL;
    }

    const parentFolder = pathSegments[pathSegments.length - 2];

    if (parentFolder === recordingId) {
      return uploadURL;
    }

    pathSegments.splice(pathSegments.length - 1, 0, recordingId);
    parsedURL.pathname = `/${pathSegments.join("/")}`;

    return parsedURL.toString();
  } catch {
    return uploadURL;
  }
};

export async function getUploadURLOld(recordingUUID: string, deviceKey: string): Promise<string> {
  try {
    const initialToken = recoverTokenInfo();
    const res = await api.post<string>(`/${API_VERSIONS.v0}/file/upload`, null, {
      params: {
        fileName: recordingUUID,
      },
      headers: {
        Accept: "*/*",
        Authorization: `Bearer ${initialToken}`,
        "X-iBabs-Device-Id": deviceKey,
      },
    });

    return res.data;
  } catch (error) {
    console.error("Error getting upload URL:", error);
    throw error;
  }
}
